import { useRefinedFacets } from '@/productDiscovery/Listings/facets/hooks/useRefinedFacets';

import { useCurrentPage } from './useCurrentPage';

export const useConditionsToDisplayCard = (
  ignoreCategoryFilter = false,
): boolean => {
  const currentPage = useCurrentPage();
  let filters = useRefinedFacets();
  if (ignoreCategoryFilter)
    filters = filters.filter(
      (filter) => filter.facetName !== 'categories.last',
    );

  return currentPage === 1 && filters.length === 0;
};
